export default {
  selectedWithCount: '已选 {number} 个 {contentName}',
  shareEntireDirectory: '整目录分享',
  afterOpenTips: '开启后，整个目录下的所有内容都会被分享\n（该目录下未来新增的内容也会自动分享）',
  afterOpenTipsTwo: '整个目录下的所有内容都会被分享（该目录下未来新增的内容也会自动分享）',
  noContent: '暂无数据',
  selectAll: '全选',
  all: '全部',
  notSelectAnyWithName: `没有选中任何 {name}`,
  cancel: '取消',
  confirm: '确认',
  customExpression: '自定义表达式',
  noPermission: '没有权限',
  enumeratedValue: '枚举值',
  description: '说明',

  required: '必需',
  optional: '非必需',
  default: '默认值',
  length: '长度',
  format: '数据格式',
  enum: '枚举',
  regexp: '正则',
  and: '且',
  value: '值',
  arrayLength: '长度',
  uniqueItems: '元素唯一',
  const: '常量值',
  multipleOf: '{multipleOf} 的倍数',
  propertiesLength: '属性数量',
  additionalItems: '附加项目',
  additionalProperties: '附加属性',
  writeOnly: '只写',
  readOnly: '只读',
  examples: '示例值',
  externalDocs: '外部文档',
  isCopied: '已复制',
  copyToClipboard: '点击复制',
  'overView.isCopied': '已复制',
  'overView.failToCopied': '复制失败，请手动复制',
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  deprecated: '已废弃',
  'error.url': 'URL 格式错误：{url}',
  note: '备注',
  tip: '提示',
  info: '信息',
  caution: '注意',
  danger: '危险',
  warning: '警告',
  check: '检查',
  name: '名称',
  'codeEditor.copy': '复制代码',
  'codeEditor.format': '格式化',
  'codeEditor.showEditor': '显示内容',

  'schemaGenerator.code': ' 代码',
  'schemaGenerator.codeGenerate': '生成模型代码',
  'schemaGenerator.more': '更多',
  'schemaGenerator.name': '数据模型名',
  'schemaGenerator.commaSeparator': '，',
  'codeEditor.wrap': '自动换行',

  'inbox.MarkAllAsRead': '全部已读',

  // markdown embed
  'githubGistRenderer.loading.message': 'Loading gist',
  'githubGistRenderer.errorLoading.message': '嵌入gist时出错',
};
